module.exports = __webpack_public_path__ + "static/media/challange.13a5acf2.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/challange.JPG
// module id = 481
// module chunks = 0